import { render, staticRenderFns } from "./WithoutActiveGrades.vue?vue&type=template&id=3b6c81ea&scoped=true&lang=pug&"
import script from "./WithoutActiveGrades.vue?vue&type=script&lang=js&"
export * from "./WithoutActiveGrades.vue?vue&type=script&lang=js&"
import style0 from "./WithoutActiveGrades.vue?vue&type=style&index=0&id=3b6c81ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c81ea",
  null
  
)

export default component.exports